import React, { forwardRef, HTMLAttributes, ChangeEvent } from 'react';
import './Toggle.scss';

interface ToggleProps extends HTMLAttributes<HTMLInputElement> {
  id: string;
  name: string;
  label: string;
  onText: string;
  offText: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Toggle = forwardRef<HTMLInputElement, ToggleProps>(
  ({ id, name, onChange, label, onText, offText, ...props }, ref) => {
    return (
      <div className='btn-container'>
        <div className='switch btn-color-mode-switch'>
          <input type='checkbox' ref={ref} name={name} id={id} onChange={onChange} {...props} />
          <label
            htmlFor={id}
            className='btn-color-mode-switch-inner'
            data-on={onText}
            data-off={offText}
          />
        </div>
      </div>
    );
  }
);
